import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type SubscriptionFragment = { id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number };

export const SubscriptionFragmentDoc = gql`
    fragment SubscriptionFragment on CustomerSubscriptionType {
  id
  pk
  subscriptionType
  name
  description
  sortOrder
}
    `;